import ChatApp from "./chatbot/ChatApp";

const Chatbot = () => {


  return (
    <ChatApp />
  );
}

export default Chatbot;